export enum DidoDocumentenControlDisplayModus {
    /** List modus */
    List,
    /** Grid modus */
    Grid
}